import { mapState } from "vuex";
export const oilGunIndexMixins = {
  computed: {
    oilGunTopBarList() {
      let topbarList = [
        {
          name: "油枪管理",
          isActive: false,
          path: "/oilGun",
          icon:require("@/assets/img/menuIcons/icon-oilGun.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
